import { Box, Typography } from '@mui/material';
import KenButton from '../KenButton';

export function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <Box role="alert" alignItems="center" justifyContent="center" display="flex" flexDirection="column">
      <Typography style={{ marginTop: 10 }}>Something went wrong</Typography>
      <KenButton onClick={resetErrorBoundary}>Click here to Refresh</KenButton>
    </Box>
  );
}
